export const isInvoiceOnly = (
  adBudgetId?: string,
  contractBalance?: number | null,
): boolean =>
  typeof adBudgetId === 'string' || typeof contractBalance === 'number';
